/* LAVAZAPAS — interacciones de las secciones personalizadas */
(function () {
  if (window.__cicloInit) return;
  window.__cicloInit = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- aparicion al hacer scroll ---------- */
  function reveals() {
    var items = document.querySelectorAll('.cc-rv:not([data-cc-seen])');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('cc-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('cc-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (el) { el.setAttribute('data-cc-seen', '1'); io.observe(el); });
  }

  /* ---------- programa de lavado ---------- */
  function programas() {
    document.querySelectorAll('.cc-prog:not([data-cc-bound])').forEach(function (group) {
      group.setAttribute('data-cc-bound', '1');
      var wm = document.getElementById(group.getAttribute('data-target'));
      group.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          group.querySelectorAll('button').forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
          b.setAttribute('aria-pressed', 'true');
          if (!wm) return;
          wm.classList.remove('is-fast', 'is-paused');
          if (b.dataset.mode === 'spin') wm.classList.add('is-fast');
          if (b.dataset.mode === 'pause') wm.classList.add('is-paused');
        });
      });
    });
  }

  /* ---------- barra de compra fija ---------- */
  function buybar() {
    var bar = document.querySelector('.cc-buybar:not([data-cc-bound])');
    if (!bar) return;
    bar.setAttribute('data-cc-bound', '1');
    var after = parseInt(bar.getAttribute('data-after') || '600', 10);
    var upd = function () { bar.classList.toggle('cc-on', window.scrollY > after); };
    window.addEventListener('scroll', upd, { passive: true });
    upd();
  }

  /* ---------- antes / despues con burbujas ---------- */
  function beforeAfter() {
    document.querySelectorAll('.cc-ba:not([data-cc-bound])').forEach(function (root) {
      root.setAttribute('data-cc-bound', '1');

      var stage = root.querySelector('.cc-ba-stage');
      var knob = root.querySelector('.cc-ba-knob');
      var canvas = root.querySelector('.cc-ba-foam');
      var ctx = canvas ? canvas.getContext('2d') : null;
      var pos = parseFloat(root.getAttribute('data-start') || '12');
      var last = pos;
      var washing = false;
      var washTimer = null;
      var bubbles = [];
      var raf = null;
      var W = 0, H = 0, dpr = 1;

      function setPos(v) {
        pos = Math.max(0, Math.min(100, v));
        root.style.setProperty('--pos', pos + '%');
        if (knob) knob.setAttribute('aria-valuenow', Math.round(pos));
      }
      setPos(pos);

      function size() {
        if (!canvas) return;
        var r = stage.getBoundingClientRect();
        W = r.width; H = r.height;
        dpr = Math.min(window.devicePixelRatio || 1, 2);
        canvas.width = Math.round(W * dpr);
        canvas.height = Math.round(H * dpr);
        canvas.style.width = W + 'px';
        canvas.style.height = H + 'px';
        if (ctx) ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      }
      size();
      if (window.ResizeObserver) new ResizeObserver(size).observe(stage);
      else window.addEventListener('resize', size);

      function spawn(n, speed) {
        if (reduce || !ctx) return;
        var x = (pos / 100) * W;
        for (var i = 0; i < n; i++) {
          bubbles.push({
            x: x + (Math.random() - 0.5) * 46,
            y: Math.random() * H,
            r: 2 + Math.random() * (6 + Math.min(speed, 10)),
            vy: -(0.25 + Math.random() * 0.9),
            vx: (Math.random() - 0.5) * 0.7,
            a: 0,
            amax: 0.35 + Math.random() * 0.5,
            life: 0,
            max: 60 + Math.random() * 70,
            w: Math.random() * 6.28
          });
        }
        if (bubbles.length > 320) bubbles.splice(0, bubbles.length - 320);
        loop();
      }

      function draw() {
        if (!ctx) return;
        ctx.clearRect(0, 0, W, H);
        for (var i = bubbles.length - 1; i >= 0; i--) {
          var b = bubbles[i];
          b.life++;
          b.y += b.vy;
          b.x += b.vx + Math.sin(b.w + b.life / 14) * 0.35;
          b.a = b.life < 12 ? (b.life / 12) * b.amax
            : b.amax * Math.max(0, 1 - (b.life - 12) / (b.max - 12));
          if (b.life > b.max || b.y < -20) { bubbles.splice(i, 1); continue; }

          var g = ctx.createRadialGradient(b.x - b.r * 0.3, b.y - b.r * 0.3, b.r * 0.1, b.x, b.y, b.r);
          g.addColorStop(0, 'rgba(255,255,255,' + (b.a * 0.55) + ')');
          g.addColorStop(0.65, 'rgba(255,255,255,' + (b.a * 0.10) + ')');
          g.addColorStop(1, 'rgba(255,255,255,' + (b.a * 0.42) + ')');
          ctx.beginPath();
          ctx.arc(b.x, b.y, b.r, 0, 6.2832);
          ctx.fillStyle = g;
          ctx.fill();

          ctx.beginPath();
          ctx.arc(b.x - b.r * 0.34, b.y - b.r * 0.34, Math.max(0.6, b.r * 0.16), 0, 6.2832);
          ctx.fillStyle = 'rgba(255,255,255,' + (b.a * 0.85) + ')';
          ctx.fill();
        }
      }

      function loop() {
        if (raf) return;
        var step = function () {
          draw();
          if (washing) spawn(1, 1);
          if (bubbles.length || washing) { raf = requestAnimationFrame(step); }
          else { raf = null; if (ctx) ctx.clearRect(0, 0, W, H); }
        };
        raf = requestAnimationFrame(step);
      }

      function startWash() {
        washing = true;
        root.classList.add('is-washing');
        clearTimeout(washTimer);
        loop();
      }
      function endWash() {
        clearTimeout(washTimer);
        washTimer = setTimeout(function () {
          washing = false;
          root.classList.remove('is-washing');
        }, 420);
      }

      function fromEvent(e) {
        var r = stage.getBoundingClientRect();
        var cx = (e.touches ? e.touches[0].clientX : e.clientX);
        return ((cx - r.left) / r.width) * 100;
      }

      var dragging = false;
      function down(e) {
        dragging = true;
        startWash();
        setPos(fromEvent(e));
        spawn(10, 6);
        if (root.setPointerCapture && e.pointerId !== undefined) {
          try { root.setPointerCapture(e.pointerId); } catch (err) {}
        }
      }
      function move(e) {
        if (!dragging) return;
        var v = fromEvent(e);
        var sp = Math.abs(v - last);
        last = v;
        setPos(v);
        spawn(Math.min(6, 1 + Math.round(sp * 1.6)), sp);
        if (e.cancelable) e.preventDefault();
      }
      function up() {
        if (!dragging) return;
        dragging = false;
        endWash();
      }

      root.addEventListener('pointerdown', down);
      root.addEventListener('pointermove', move);
      window.addEventListener('pointerup', up);
      root.addEventListener('pointercancel', up);

      if (knob) {
        knob.addEventListener('keydown', function (e) {
          var d = 0;
          if (e.key === 'ArrowLeft') d = -4;
          if (e.key === 'ArrowRight') d = 4;
          if (e.key === 'Home') { setPos(0); return; }
          if (e.key === 'End') { setPos(100); return; }
          if (!d) return;
          e.preventDefault();
          startWash();
          setPos(pos + d);
          spawn(5, 4);
          endWash();
        });
        knob.addEventListener('click', function (e) { e.preventDefault(); });
      }

      function ease(x) { return 1 - Math.pow(1 - x, 3); }

      /* demostracion automatica la primera vez que se ve */
      if (!reduce && 'IntersectionObserver' in window) {
        var shown = false;
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (en) {
            if (!en.isIntersecting || shown) return;
            shown = true;
            io.disconnect();
            var t0 = performance.now();
            var from = pos, to = 62, back = 30, dur = 1500;
            startWash();
            var anim = function (t) {
              var k = Math.min(1, (t - t0) / dur);
              var e1 = k < 0.5 ? k * 2 : 1;
              var e2 = k < 0.5 ? 0 : (k - 0.5) * 2;
              var v = k < 0.5 ? from + (to - from) * ease(e1) : to + (back - to) * ease(e2);
              setPos(v);
              if (k < 1) requestAnimationFrame(anim); else endWash();
            };
            requestAnimationFrame(anim);
          });
        }, { threshold: 0.45 });
        io.observe(root);
      }
    });
  }

  function boot() {
    document.documentElement.classList.add('cc-js');
    reveals();
    programas();
    buybar();
    beforeAfter();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:select', boot);
})();
